import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import PdfSvgV2 from '../../../../../../assets/svg-fc/PdfSvgV2';
import { getAmountWithCurrency } from '../../../../../../helpers/common';
import './RecentQuoteCard.scss';

interface RecentQuoteCardProps {
  quoteAmount: number;
  quoteDate?: string;
  vendorName?: string;
  onViewPDF?: () => void;
}

const RecentQuoteCard: React.FC<RecentQuoteCardProps> = ({
  quoteAmount,
  quoteDate,
  vendorName,
  onViewPDF,
}) => {
  return (
    <Box className="recentQuoteCard">
      <Box className="recentQuoteCardContent">
        <Box className="recentQuoteCardInfo">
          {vendorName && <Typography className="recentQuoteCardVendorName">{vendorName}</Typography>}
          {quoteDate && <Typography className="recentQuoteCardDate">{quoteDate}</Typography>}
        </Box>
        <Box className="recentQuoteCardAmount">
          <Typography className="recentQuoteCardAmountText">{getAmountWithCurrency(quoteAmount)}</Typography>
        </Box>
      </Box>
      {onViewPDF && (
        <Link
          component="button"
          variant="body2"
          onClick={onViewPDF}
          className="recentQuoteCardViewPDF"
        >
          <PdfSvgV2 />
          <Typography component="span">View Quote PDF</Typography>
        </Link>
      )}
    </Box>
  );
};

export default RecentQuoteCard;
